import { Button, Row } from 'components';
import { theme } from 'lib';
import React from 'react';
import { useTranslation } from 'react-i18next';

/** The one centred Save of a GoalRush rules form. */
const SaveButton = ({ saving, disabled, onClick }) => {
  const { t } = useTranslation();
  return (
    <Row center wid="100%">
      <Button
        text={saving ? t('admin.goalRush.saving') : t('admin.goalRush.save')}
        onClick={onClick}
        bg={theme.SECONDARY}
        loading={saving}
        disabled={disabled || saving}
        small
        wid="160px"
      />
    </Row>
  );
};

export default SaveButton;
